import {
  Button,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Logo } from '@/components';
import { AlertComponent } from '@/components';
import { authStore, login } from '@/store'; 
import { useStore } from '@tanstack/react-store';
import { useNavigate } from '@tanstack/react-router';
import { routesUrl } from '@/constants';

export const LoginForm = () => {
  const navigate = useNavigate();
  const authState = useStore(authStore, (state) => ({
    isLoading: state.state === "loading",
    error: state.isError ? 'Credenziali non valide o errore del server' : null,
  }));

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Email non valida').required('Email obbligatoria'),
      password: Yup.string().required('Password obbligatoria'),
    }),
    onSubmit: async (values) => {
      console.log('Tentativo di login con:', values);
      try {
        await login(values, () => navigate({ to: routesUrl.dashboard }));
      } catch (error) {
        console.error('Errore durante il login:', error);
      }
    },
  });

  return (
    <Container maxW="md" py={{ base: '12', md: '24' }}>
      <Stack spacing="8">
        <Stack spacing="6">
          <HStack justify="center" mb={4}>
            <Logo />
          </HStack>
          {/* <Stack p={4} bg="blue.50" borderRadius="md" spacing={2}>
            <Heading size="sm">Environment Variables (Test)</Heading>
            <pre style={{ overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
              {JSON.stringify(envVariables, null, 2)}
            </pre>
          </Stack> */}
          <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
            <Heading size={{ base: 'xs', md: 'sm' }}>Accedi al tuo account</Heading>
          </Stack>
        </Stack>

        <form onSubmit={formik.handleSubmit}>
          <Stack spacing="5">
            <FormControl isInvalid={!!(formik.touched.email && formik.errors.email)}>
              <FormLabel htmlFor="email">Email</FormLabel>
              <Input
                id="email"
                type="email"
                placeholder="Inserisci la tua email"
                {...formik.getFieldProps('email')}
              />
              {formik.touched.email && formik.errors.email ? (
                <Text mt={1} color="red.500" fontSize="sm">
                  {formik.errors.email}
                </Text>
              ) : null}
            </FormControl>

            <FormControl isInvalid={!!(formik.touched.password && formik.errors.password)}>
              <FormLabel htmlFor="password">Password</FormLabel>
              <Input
                id="password"
                type="password"
                placeholder="********"
                {...formik.getFieldProps('password')}
              />
              {formik.touched.password && formik.errors.password ? (
                <Text mt={1} color="red.500" fontSize="sm">
                  {formik.errors.password}
                </Text>
              ) : null}
            </FormControl>
          </Stack>

          <HStack justify="space-between" mt={2}>
            <Checkbox
              onChange={formik.handleChange}
              name="rememberMe"
            >
              Ricordami
            </Checkbox>
            {/* <Button variant="link" size="sm">
              Password dimenticata
            </Button> */}
          </HStack>

          {authState.error && (
            <AlertComponent 
              status="error" 
              title="Errore durante il login" 
              description={authState.error} // Mostra l'errore restituito dal backend
            />
          )}

          <Stack spacing="4" mt={4}>
            <Button type="submit" isLoading={authState.isLoading} disabled={authState.isLoading}>
              Accedi
            </Button>
          </Stack>
        </form>
      
      </Stack>
    </Container>
  );
};
